import { AbstractJavascriptFunctionCallFactory } from "./AbstractJavascriptFunctionCallFactory";
import { AbstractJavascriptFunctionCallVO } from "./AbstractJavascriptFunctionCallVO";
import { JavascriptCallSetCashHashVO } from "./JavascriptCallSetCashHashVO";
/**
 * Created with IntelliJ IDEA.
 * User: sronge
 * Date: 13.06.13
 * Time: 16:49
 * To change this template use File | Settings | File Templates.
 */


import { BasicController } from "../../BasicController";

export class JavascriptCallSetCashHashFactory implements AbstractJavascriptFunctionCallFactory {
    public createVO(): AbstractJavascriptFunctionCallVO {
        let vo: JavascriptCallSetCashHashVO = new JavascriptCallSetCashHashVO(BasicController.getInstance().paymentHash);
        return vo;
    }
}

